import { Component } from '@angular/core';

@Component({
  selector: 'app-common-panel',
  templateUrl: './common-panel.component.html',
  styleUrls: ['./common-panel.component.scss'],
  standalone :false
})
export class CommonPanelComponent {

}
